'use client';

import { useRef, useState } from 'react';
import { Modal, Sidebar } from 'ui';

import { AuthModal } from '@/shared/components/account/authModal';
import { useBasket } from '@/shared/context/basket-context';

import styles from './GeneralHeader.module.scss';
import { HeaderCart } from './headerCart';
import { HeaderSidebar } from './headerSidebar';
import { HeaderTopBar } from './headerTopBar';
import { HeaderProps } from './types';

export function GeneralHeader({
  sidebarMenu,
  topMenu,
  shippingMethods,
}: HeaderProps) {
  const {
    isCartSidebarOpen,
    setIsCartSidebarOpen,
    isCategorySidebarOpen,
    setIsCategorySidebarOpen,
    isLoginModalOpen,
    setIsLoginModalOpen,
    canRenderCategorySidebarOpen,
    setCanRenderCategorySidebarOpen,
  } = useBasket();
  const [open, setOpen] = useState<string[]>([]);
  const mobileSearchInput = useRef<HTMLInputElement>(null);

  const handleHeaderSidebarClose = () => {
    setIsCategorySidebarOpen(false);

    setTimeout(() => {
      setOpen([]);
    }, 200);
  };

  const handleHamburgerHover = () => {
    if (!canRenderCategorySidebarOpen) {
      setCanRenderCategorySidebarOpen(true);
    }
  };

  return (
    <>
      <HeaderTopBar
        mobileSearchInput={mobileSearchInput}
        topMenu={topMenu}
        onHamburgerPress={() => setIsCategorySidebarOpen(true)}
        onHamburgerHover={() => handleHamburgerHover()}
        onCartPress={() => setIsCartSidebarOpen(true)}
        onAccountPress={() => setIsLoginModalOpen(true)}
      />

      {canRenderCategorySidebarOpen && (
        <Sidebar
          isOpen={isCategorySidebarOpen}
          side="left"
          onOverlayPress={handleHeaderSidebarClose}
          wrapperClassName={styles.generalHeader__headerSidebar}
        >
          <HeaderSidebar
            mobileSearchInput={mobileSearchInput}
            sidebarMenu={sidebarMenu}
            topMenu={topMenu}
            open={open}
            onCloseButtonPress={handleHeaderSidebarClose}
            setOpen={setOpen}
          />
        </Sidebar>
      )}

      <Sidebar
        isOpen={isCartSidebarOpen}
        side="right"
        onOverlayPress={() => setIsCartSidebarOpen(false)}
      >
        <HeaderCart
          shippingMethods={shippingMethods}
          onCloseButtonPress={() => setIsCartSidebarOpen(false)}
        />
      </Sidebar>

      <Modal
        isOpen={isLoginModalOpen}
        onOverlayPress={() => setIsLoginModalOpen(false)}
      >
        <AuthModal />
      </Modal>
    </>
  );
}
